import styled from 'styled-components';
import {device} from '../../../styled/device';
import Link from '../../acommon/Link';
import Modal from '../../Modal';
import {Button} from '../../Button';

export const TextLeft = styled.div`
  text-align: left;
`;

export const InvoicingDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: ${device.tablet}) {
    margin: 20px 0 -50px;
  }
  @media (min-width: 760px) and (max-width: 770px) {
    margin: 20px 0 -150px;
  }
`;
export const InvoicingDetailsContent = styled.form`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  row-gap: 20px;
`;
export const InvoicingDetailsSectionWrapper = styled.div``;
export const InvoicingDetailsSectionTitle = styled.div`
  font-family: Poppins-Medium, sans-serif;
  text-align: left;
`;
export const InvoicingDetailsSectionChildrenContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
`;
export const InvoicingDetailsSectionSubmitButtonWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  margin: 20px 0 70px;
`;

export const SectionContainer = styled.div`
  cursor: pointer;
`;
export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  margin: 20px 0;
  border-bottom: 1px solid #e8e8e8;
`;

export const Title = styled.div`
  text-align: left;
  font-weight: 500;
`;

export const Summary = styled.div``;
export const SummaryWrapper = styled.div`
  grid-area: 1 / 2 / last-line / end;

  & div:first-child {
    cursor: default;
  }
`;

export const BaseSummaryItem = styled.div`
  width: 100%;
  padding: 10px;
  margin: 15px 0;
  align-items: center;
`;

export const SummaryItem = styled(BaseSummaryItem)`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  justify-items: stretch;
`;
export const SummaryTitle = styled.div`
  text-align: left;
`;
export const SummaryPrice = styled.div`
  text-align: right;
`;

export const TotalWrapper = styled(BaseSummaryItem)`
  display: flex;
  justify-content: space-between;
  background-color: #f4f5f6;
  border-radius: 8px;
  font-weight: bold;
`;

export const TotalTitle = styled.div`
  font-family: Poppins-Bold, sans-serif;
  font-size: 20px;

  & span {
    font-family: Poppins-Regular, sans-serif;
    color: #6b6b95;
  }
`;

export const TotalPrice = styled.div`
  font-family: Poppins-Bold, sans-serif;
  font-size: 20px;
`;

export const SubmitButtons = styled.div`
  display: inline-flex;
  flex-direction: column;
`;

export const ButtonStyled = styled(Button)`
  padding: 0 25px;
  width: 300px;
`;

export const SubmitButtonWrapper = styled.div`
  margin: 30px 0;

  & .progress {
    display: none;
  }

  @media (max-width: ${device.tablet}) {
    & .progress {
      display: inline;
      font-family: Poppins-Medium, sans-serif;
      font-size: 21px;
      color: #777e90;
    }

    position: fixed;
    margin: 0;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    width: 100%;
    align-items: center;
    background-color: #f7fafc;
    border-top: 1px solid #b1b5c4;
    bottom: 0;
    left: 0;
    z-index: 5;
  }
`;

export const LinkStyled = styled(Link)`
  font-family: Poppins-Medium, sans-serif;
  font-size: 16px;

  &:hover {
    opacity: 0.75;
  }
`;

export const DeleteButton = styled.span`
  cursor: pointer;
`;

export const ModalDeleteDeal = styled(Modal)`
  justify-content: center;

  & .popup-content {
    max-width: 400px !important;
    min-height: auto !important;
  }

  & .modalDeleteDealButton {
    margin: 0 auto;
  }
`;

export const ModalDeleteDealButton = styled(Button)`
  margin: 0 auto;
  justify-content: center;
`;

export const Slash = styled.div`
  font-family: ProximaNova-Regular, sans-serif;
  font-size: 18px;
  color: #161643;
  margin-right: 6px;
`;

export const ExpiryDateInput = styled.input`
  border: none;
  width: 30px;
  height: 19px;
  font-family: sans-serif;
  font-size: 16px;
  color: #161643;
  outline: none;
  text-align: center;
  padding: 0;
  &::placeholder {
    color: rgb(45 80 142 / 34%);
  }
`;
